exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1c8a28dd] .modal-body,[data-v-1c8a28dd] .modal-content{overflow:visible!important}", ""]);

// exports
